module.exports = __webpack_public_path__ + "img/creationBarquette.f0335272.png";